export const GET_BULK_ACTIONS = 'GET_BULK_ACTIONS';
export const GET_BULK_ACTIONS_FAIL = 'GET_BULK_ACTIONS_FAIL';
export const GET_BULK_ACTIONS_SUCCESS = 'GET_BULK_ACTIONS_SUCCESS';

export const BULK_ACTIONS_TASK_ADD = 'BULK_ACTIONS_TASK_ADD';
export const BULK_ACTIONS_TASK_ADDED_SUCCESSFULLY = "BULK_ACTIONS_TASK_ADDED_SUCCESSFULLY";
export const BULK_ACTIONS_TASK_ADD_FAIL = 'BULK_ACTIONS_TASK_ADD_FAIL';

export const BULK_ACTION_TASK_DELETE_REQUEST = 'BULK_ACTION_TASK_DELETE_REQUEST';
export const BULK_ACTION_TASK_DELETE_SUCCESS = 'BULK_ACTION_TASK_DELETE_SUCCESS';
export const BULK_ACTION_TASK_DELETE_FAIL = 'BULK_ACTION_TASK_DELETE_FAIL';
export const RESET_BULK_ACTION_TASK_DELETE = 'RESET_BULK_ACTION_TASK_DELETE';

export const BULK_ACTION_TASK_REPORT_REQUEST_GET = 'BULK_ACTION_TASK_REPORT_REQUEST_GET';
export const BULK_ACTION_TASK_REPORT_RESPONSE_GET_SUCCESS = 'BULK_ACTION_TASK_REPORT_RESPONSE_GET_SUCCESS';
export const BULK_ACTION_TASK_REPORT_RESPONSE_GET_FAIL = 'BULK_ACTION_TASK_REPORT_RESPONSE_GET_FAIL';

export const BULK_ACTION_TASK_REQUEST_EDIT = 'BULK_ACTION_TASK_REQUEST_EDIT';
export const BULK_ACTION_TASK_RESPONSE_EDIT_FAIL = 'BULK_ACTION_TASK_RESPONSE_EDIT_FAIL';
export const BULK_ACTION_TASK_RESPONSE_EDIT_SUCCESS = 'BULK_ACTION_TASK_RESPONSE_EDIT_SUCCESS';
export const BULK_ACTION_TASK_UPDATED_SUCCESFULLY = 'BULK_ACTION_TASK_UPDATED_SUCCESFULLY';
export const BULK_ACTION_TASK_EDIT_SUCCESS_MESSAGE = 'BULK_ACTION_TASK_EDIT_SUCCESS_MESSAGE';